var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowSelect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80812 7.70711C8.36181 8.09763 7.63819 8.09763 7.19188 7.70711L0.334735 1.70711C-0.111579 1.31658 -0.111579 0.683416 0.334735 0.292892C0.781047 -0.0976328 1.50467 -0.0976327 1.95098 0.292892L8 5.58579L14.049 0.292893C14.4953 -0.0976316 15.219 -0.0976315 15.6653 0.292893C16.1116 0.683417 16.1116 1.31658 15.6653 1.70711L8.80812 7.70711Z",
    fill: "#C1DD7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowSelect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_select.f1c82c1d81ed9c29b84c774cb483ca54.svg";